import { BaseError } from './BaseError';

export enum SubscriptionStateErrorReason {
    InvalidApplicationServerKey = 'InvalidApplicationServerKey',
}

export class SubscriptionStateError extends BaseError {
    reason: SubscriptionStateErrorReason;

    constructor(reason: keyof typeof SubscriptionStateErrorReason) {
        let errorMsg: string = '';

        switch (reason) {
            case SubscriptionStateErrorReason.InvalidApplicationServerKey:
                errorMsg = `Missing required 'applicationServerKey'.`;
                break;
            default:
                break;
        }

        super(errorMsg);

        this.reason = SubscriptionStateErrorReason[reason] ?? reason;

        Object.setPrototypeOf(this, SubscriptionStateError.prototype);
    }
}
